import type { ArgoCDApplicationResource, TenantResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ExpandingChipList } from "~/areas/infrastructure/components/ArgoCDInstances/components/ExpandingChipList";
import { tenantChipList } from "~/components/Chips/index";
type ArgoCDApplicationTenantsChipListProps = {
    application: ArgoCDApplicationResource;
    tenants: TenantResource[];
};
export const ArgoCDApplicationTenantsChipList = (props: ArgoCDApplicationTenantsChipListProps) => {
    const tenantIds = [...new Set(props.application.Sources.map((src) => src.TenantId).filter((id) => id !== null))];
    return <ExpandingChipList singularName={"tenant"} ids={tenantIds} renderChipList={(ids) => tenantChipList(props.tenants, ids)}/>;
};
